import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/icons/Logo.svg";
import { classNames } from "../helper/classNames";

const BrandLogo = ({ imgClass, className }) => {
  const navigate = useNavigate();
  return (
    <div
      className={classNames(className, "py-6 cursor-pointer")}
      onClick={() => navigate("/")}
    >
      <img className={classNames(imgClass)} src={Logo} alt="Logo" />
    </div>
  );
};

export default BrandLogo;
